<template>
  <div>
    {{ label }}
    <span v-show="!loading" :style="{ color: valid ? 'black' : 'red' }">
      {{ formatResult(originalValue) }} <br>
      <a v-for="url in imageUrls" :href="url" target="_blank">預覽 </a>
    </span>
    <b-spinner v-show="loading" class="spinner-border-sm" variant="success" label="Spinning" />
  </div>
</template>

<script>
export default {
  name: 'BaseListItem',
  props: {
    label: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    formatResult: {
      type: Function,
      default: value => value,
    },
    originalValue: {
      type: [String, Number],
      default: '',
    },
    imageUrls: {
      type: Array,
      default: [],
    },
    valid: {
      type: Boolean,
      default: true,
    }
  },
};
</script>
